import { render, staticRenderFns } from "./MagicCheckbox.vue?vue&type=template&id=96394af0&scoped=true&functional=true"
import script from "./MagicCheckbox.vue?vue&type=script&lang=js"
export * from "./MagicCheckbox.vue?vue&type=script&lang=js"
import style0 from "./MagicCheckbox.vue?vue&type=style&index=0&id=96394af0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  "96394af0",
  null
  
)

export default component.exports